import Vue from 'vue'
import io from 'socket.io-client'
import Store from './store'

const socket = io.connect(process.env.SOCKET)

function notify (message = '', type = 'is-dark') {
  Vue.prototype.$snackbar.open({
    duration: 5000,
    message,
    type,
    actionText: 'OK',
    queue: false
  })
}

socket.on('connect', function () {
  Vue.prototype.$snackbar.open('Verbonden met de socket server.')
})

socket.on('purchaseGenerated', function () {
  Vue.prototype.$snackbar.open('Inkoop factuur gegenereerd.')
  Store.dispatch('getPurchasesCompleted')
})

socket.on('receiptAdded', function () {
  notify('Bonnetje is toegevoegd aan de wachtrij')
  Store.dispatch('getIncompleteReceipts')
})

socket.on('creditcardslipAdded', function () {
  notify('Creditcardslip is toegevoegd aan de wachtrij')
  Store.dispatch('getIncompleteCreditcardslips')
})



// WEBPACK FOOTER //
// ./src/socket.js